<template lang="html">
  <layout-resource
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:normal="{resource}">
      <div class="d-flex flex-column">
        <span class="font-weight-bold">
          {{resource.item.title}}
        </span>
        <span>
          {{resource.item.seats}} <v-icon small>mdi-account-multiple</v-icon>
        </span>
      </div>
    </template>
    <template v-slot:small="{resource}">
      <div class="d-flex flex-column">
        <span class="font-weight-bold">
          {{resource.item.number}}
        </span>
        <span>
          {{resource.item.seats}} <v-icon small>mdi-account-multiple</v-icon>
        </span>
      </div>
    </template>
    <template v-slot:mini="{resource}">
      <div class="d-flex flex-column">
        <span class="font-weight-bold">
          {{resource.item.number}}
        </span>
        <span>
          {{resource.item.seats}}
        </span>
      </div>
    </template>
    <template v-slot:micro="{resource}">
      <span class="font-weight-bold">{{resource.item.number}}</span>
      <span>({{resource.item.seats}})</span>
    </template>
    <template v-slot:nano="{resource}">
      <span class="font-weight-bold">{{resource.item.number}}</span>
    </template>
  </layout-resource>
</template>

<script>
import {LayoutResource} from 'dync-booking'

export default {
  inheritAttrs: false,
  data() {
    return {};
  },
  components: {
    LayoutResource
  }
}
</script>

<style lang="scss" scoped>
</style>
